jQuery(function ($) {
  // この中であればWordpressでも「$」が使用可能になる

  var topBtn = $(".pagetop");
  topBtn.hide();

  // ボタンの表示設定
  $(window).scroll(function () {
    if ($(this).scrollTop() > 70) {
      // 指定px以上のスクロールでボタンを表示
      topBtn.fadeIn();
    } else {
      // 画面が指定pxより上ならボタンを非表示
      topBtn.fadeOut();
    }
  });

  // ボタンをクリックしたらスクロールして上に戻る
  topBtn.click(function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      300,
      "swing"
    );
    return false;
  });

  // スムーススクロール (絶対パスのリンク先が現在のページであった場合でも作動)

  $(document).on("click", 'a[href*="#"]', function () {
    let time = 400;
    let header = $("header").innerHeight();
    let target = $(this.hash);
    if (!target.length) return;
    let targetY = target.offset().top - header;
    $("html,body").animate({ scrollTop: targetY }, time, "swing");
    return false;
  });

  $(document).ready(function () {
    // ハンバーガーメニューがクリックされた時の処理
    $(".js-hamburger").click(function () {
      // ハンバーガーメニューに--activeクラスを付与または削除
      $(this).toggleClass("--active");
      // スライドメニューに--activeクラスを付与または削除
      $(".js-slideMenu").toggleClass("--active");
    });

    // 【追加】ハンバーガーメニュー内のリンクがクリックされた時の処理
    $(".js-slideMenu a").click(function () {
      // ハンバーガーメニューとスライドメニューの--activeクラスを削除して閉じる
      $(".js-hamburger").removeClass("--active");
      $(".js-slideMenu").removeClass("--active");
    });
  });

  //ハンバーガーメニュー
  // let state = false;
  // let pos;
  // $(document).ready(function () {
  //   if (window.innerWidth <= 640) {
  //     // js-hamburgerをクリックしたときの処理
  //     $(".js-hamburger").click(function () {
  //       // js-hamburgerに--activeをトグル
  //       if (state == false) {
  //         pos = $(window).scrollTop();
  //         $("body").addClass("--fixed").css({ top: -pos });
  //         state = true;
  //       } else {
  //         $("body").removeClass("--fixed").css({ top: 0 });
  //         window.scrollTo(0, pos);
  //         state = false;
  //       }
  //     });
  //   }
  // });

  // リクルート追従、footerの位置で消える
  $(window).scroll(function () {
    $("#footer").each(function () {
      var position = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > position - windowHeight + 200) {
        $(".button-under").hide();
      } else {
        $(".button-under").show();
      }
    });
  });

  // 追従ボタンを×で閉じる
  $(".button-under__close").click(function () {
    $(".button-under").remove();
  });

  // ヘッダーリンクの現在地表示
  // $(".nav-link").each(function () {
  //   if (this.href === window.location.href) {
  //     $(this).addClass("--current");
  //   }
  // });
  var currentUrl = window.location.href; // 現在のページのURLを取得
  $(".nav-link").each(function () {
    // 'RECRUITMENT' ナビゲーションリンクのみ特別扱いする
    if (
      $(this).text() === "RECRUITMENT" &&
      currentUrl.includes("/recruitment/")
    ) {
      $(this).addClass("--current");
    } else if (this.href === currentUrl) {
      // それ以外のリンクには、URLが完全一致する場合にのみ "--current" クラスを追加
      $(this).addClass("--current");
    }
  });

  /*-------------------------     スライダー    -------------------------*/
  // Swiper-fv(TOP,recruit)
  const fvSwiper = new Swiper(".js-fv-swiper", {
    loop: true,
    // speed: 3000,
    speed: 5000,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      // delay: 1500,
      delay: 8000,
      disableOnInteraction: false,
    },
  });

  //ABOUT US(無限スライダー)
  const swiper = new Swiper(".js-infiniteSlider", {
    loop: true, // ループ有効
    slidesPerView: 2, // 一度に表示する枚数
    speed: 12000, // ループの時間
    allowTouchMove: false, // スワイプ無効
    autoplay: {
      delay: 0, // 途切れなくループ
    },
    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      641: {
        slidesPerView: 5,
      },
    },
  });

  //ABOUT US(私たちが大切にすること flipster)
  var coverflow = $("#coverflow").flipster({
    itemContainer: "ul",
    itemSelector: "li",
    style: "coverflow",
    // Switch between items with click
    click: false,

    // Enable left/right arrow navigation
    keyboard: false,

    // Enable scrollwheel navigation (up = left, down = right)
    scrollwheel: false,

    // Enable swipe navigation for touch devices
    touch: true,

    // If true, flipster will insert an unordered list of the slides
    nav: false,

    // If true, flipster will insert Previous / Next buttons
    buttons: true,

    // Changes the text for the Previous button
    buttonPrev: "Previous",

    // Changes the text for the Next button
    buttonNext: "next",
    spacing: -0.9,

    // autoplay: 5000,
    loop: true,
    nav: "after",
    click: true,
  });

  //ABOUT US(私たちが大切にすること Swiper)
  const valueSwiper = new Swiper(".swiper--sp", {
    // Optional parameters
    direction: "horizontal",
    loop: true,
    spaceBetween: 30, // スライド間の距離
    centeredSlides: true, // アクティブなスライドを中央にする

    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    // Navigation arrows
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next",
    },

    // And if we need scrollbar
    scrollbar: {
      el: ".swiper-scrollbar",
    },
  });

  //BUSINESS(鋳造品データ)
  // サムネイル
  const sliderThumbnail = new Swiper(".js-thumbSlider", {
    slidesPerView: 7, // サムネイルの枚数
  });
  // スライダー
  const slider = new Swiper(".js-businessSlider", {
    loop: true,
    // 前後の矢印
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: sliderThumbnail,
    },
  });

  //Recruitment(先輩インタビュー)
  const recruitSwiper = new Swiper(".js-recruitSwiper", {
    slidesPerView: 1, // スライド数
    spaceBetween: 24, // スライド間の余白
    grabCursor: true, // カーソル
    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      641: {
        slidesPerView: 3,
        spaceBetween: "4.5%", // スライド間の余白
      },
    },
  });
});
